import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useXeroIntegration } from 'lib/hooks/useXeroIntegration'

/**
 * The backend has no eligibility endpoint today — eligibility is only
 * evaluated inside the generate/download gate, which 404s. So we derive it
 * client-side from the same two signals the backend uses: the analysis-report
 * flag AND a connected Xero integration. Mirrors `useShouldShowXeroMappings`.
 */
export const useAnalysisReportEligibility = (): boolean => {
  const flags = useFeatureFlags()
  const { xeroIntegration } = useXeroIntegration()

  return Boolean(
    flags.isRevRecAnalysisReportEnabled && xeroIntegration?.enabled
  )
}
